import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
import { FolderSummary } from './folders';
import { FormSummary } from './forms';
import { ParentFolder } from './parent-folder';
export var WorkspaceSearchResponse = /*#__PURE__*/function (_ValueObject) {
  _inherits(WorkspaceSearchResponse, _ValueObject);

  var _super = _createSuper(WorkspaceSearchResponse);

  function WorkspaceSearchResponse() {
    _classCallCheck(this, WorkspaceSearchResponse);

    return _super.apply(this, arguments);
  }

  _createClass(WorkspaceSearchResponse, [{
    key: "forms",
    get: function get() {
      return this.props.forms;
    }
  }, {
    key: "folders",
    get: function get() {
      return this.props.folders;
    }
  }, {
    key: "parentFolders",
    get: function get() {
      return this.props.parentFolders;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.forms,
        argumentName: 'Form Summaries'
      }, {
        argument: props.folders,
        argumentName: 'Folder Summaries'
      }, {
        argument: props.parentFolders,
        argumentName: 'Parent Folders Summaries'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new WorkspaceSearchResponse(props));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var forms = data.forms,
            folders = data.folders,
            parentFolders = data.parentFolders;
        var formSummaries = forms.map(function (f) {
          FormSummary.create({
            id: f.id,
            title: f.title,
            folderId: f.folderId,
            updatedAt: f.updatedAt,
            status: f.status
          }).getValue();
        });
        var folderSummaries = folders.map(function (f) {
          return FolderSummary.create({
            id: f.id,
            title: f.title,
            parentId: f.parentId
          }).getValue();
        });
        var parentFolderSummaries = parentFolders.map(function (p) {
          return ParentFolder.create({
            id: p.id,
            title: p.title,
            level: p.level
          }).getValue();
        });
        return this.create({
          forms: formSummaries,
          folders: folderSummaries,
          parentFolders: parentFolderSummaries
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return WorkspaceSearchResponse;
}(ValueObject);